<template>
  <div>
    <b-alert v-if="!available" show variant="secondary">
      AI Assistant ของคลินิกนี้ยังไม่เปิดใช้งาน — ผู้ใช้จะเชื่อมต่อได้หลังจากเปิดใช้งานแล้ว
    </b-alert>
    <label class="font-weight-bold mb-1">URL สำหรับเชื่อมต่อ (Connector URL)</label>
    <b-input-group class="mb-2">
      <b-form-input :value="connectorUrl" readonly @focus="$event.target.select()" />
      <b-input-group-append>
        <b-button variant="outline-primary" @click="copy">
          <i class="far fa-clone mr-1"></i>{{ copied ? "คัดลอกแล้ว" : "คัดลอก" }}
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <small class="text-muted d-block mb-3">
      URL นี้ใช้ได้กับคลินิกนี้เท่านั้น ผู้ใช้แต่ละคนเข้าสู่ระบบด้วยบัญชี Tantatat ของตัวเอง
      และ AI เห็นข้อมูลเฉพาะตามสิทธิ์ของผู้ใช้คนนั้น
    </small>
    <b-row>
      <b-col md="6" class="mb-3">
        <h6><i class="fas fa-comment-dots mr-1"></i>Claude (claude.ai / Claude Desktop)</h6>
        <ol class="pl-3 mb-0">
          <li>เปิด Settings → Connectors แล้วกด Add custom connector</li>
          <li>ตั้งชื่อ เช่น “Tantatat” และวาง URL ด้านบน</li>
          <li>กด Connect แล้วเข้าสู่ระบบด้วยบัญชี Tantatat</li>
          <li>ตรวจชื่อคลินิกและสาขาในหน้ายินยอม แล้วกด “อนุญาต”</li>
          <li>เริ่มถามได้เลย เช่น “สรุปรายได้เดือนนี้แยกตามสาขา”</li>
        </ol>
      </b-col>
      <b-col md="6" class="mb-3">
        <h6><i class="fas fa-comments mr-1"></i>ChatGPT</h6>
        <ol class="pl-3 mb-0">
          <li>เปิด Settings → Apps &amp; Connectors → Advanced settings แล้วเปิด Developer mode (ต้องใช้แพ็กเกจที่รองรับ)</li>
          <li>กด Create เพื่อเพิ่ม connector ใหม่ วาง URL ด้านบน และเลือกการยืนยันตัวตนแบบ OAuth</li>
          <li>เข้าสู่ระบบด้วยบัญชี Tantatat แล้วกด “อนุญาต”</li>
          <li>ในหน้าแชท เลือกใช้ connector “Tantatat” แล้วเริ่มถาม</li>
        </ol>
      </b-col>
    </b-row>
    <small class="text-muted">
      ชื่อเมนูอาจแตกต่างตามเวอร์ชันของผู้ให้บริการ AI · ยกเลิกการเชื่อมต่อได้จากหน้านี้หรือจากเมนูของผู้ให้บริการ AI
    </small>
  </div>
</template>

<script>
export default {
  name: "McpConnectGuide",
  props: {
    connectorUrl: { type: String, required: true },
    available: { type: Boolean, default: true },
  },
  data() {
    return { copied: false };
  },
  methods: {
    async copy() {
      try {
        await navigator.clipboard.writeText(this.connectorUrl);
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
        }, 2000);
      } catch (error) {
        console.error("McpConnectGuide: copy failed", error);
      }
    },
  },
};
</script>
